import { RouteItem } from "./Router";
import HomePage from "./../pages/Home/Home";
import PartiteOdiernePage from './../pages/PartiteOdierne/PartiteOdierne';
import BlogPage from './../pages/Articoli/Blog';
import MagazinePage from './../pages/Articoli/Magazine';
import NotFoundPage from './../pages/Error/NotFound';
import ContattiPage from './../pages/Contatti/Contatti';
import RicercaPage from "../pages/Ricerca";
import LoginPage from "../pages/Auth/Login";
import RegistrazionePage from "../pages/Auth/Registrazione";
import RecuperaPasswordPage from "../pages/Auth/RecuperaPassword";
import ProfiloPage from "../pages/PrivateArea/Profilo";
import CambiaPasswordPage from "../pages/PrivateArea/CambiaPassword";
import LogoutPage from "../pages/Auth/Logout";
import ArticoloPage from "../pages/Articoli/Articolo";
import VideoPage from "../pages/Articoli/Video/Video";
import GiocatorePage from "../pages/Categorie/Giocatore";
import SocietaPage from "../pages/Categorie/Societa";
import VideoListPage from "../pages/Articoli/Video/ElencoVideo";
import ClassificaCategoriaPage from "../pages/Categorie/ClassificaCategoria/ClassificaCategoria";
import ArchivioPage from "../pages/Articoli/Archivio";
import AttivaUtentePage from "../pages/Auth/AttivaUtente";

const componentMap: {[key: string]: (props?: any) => JSX.Element} = {
    "partiteOdierne": PartiteOdiernePage,
    "competizioni": ClassificaCategoriaPage,
    "archivio": ArchivioPage,
    "articoli": BlogPage,
    "magazine": MagazinePage,
    "home": HomePage,
    "contatti": ContattiPage,
    "video": VideoListPage
};

export const resolveComponent = (
    type: string,
    params?: object
) => {
    const Component = componentMap[type] || NotFoundPage;

    // Ritorna un componente con i parametri passati come props
    return (props: any) => <Component {...props} {...params} />;
};

export const hasComponent = (type: string) => {
    return componentMap[type] !== undefined ? true : false
}

export default async function getStaticRoutes(): Promise<RouteItem[]> {
    return [{
        id: "articolo",
        path: "articolo/:id",
        component: ArticoloPage,
        name: "Articolo",
    }, {
        id: "classifica",
        path: "categorie/classifiche/:name",
        component: ClassificaCategoriaPage,
        name: "Classifica",
    }, {
        id: "video",
        path: "video/:id",
        component: VideoPage,
        name: "Video",
    }, {
        id: "societa",
        path: "societa/:id",
        component: SocietaPage,
        name: "Società",
    }, {
        id: "giocatore",
        path: "giocatore/:id",
        component: GiocatorePage,
        name: "Giocatore",
    }, {
        id: "ricerca",
        path: "ricerca",
        component: RicercaPage,
        name: "Ricerca",
    }, {
        id: "accedi",
        path: "accedi",
        component: LoginPage,
        name: "Accedi",
    }, {
        id: "registrazione",
        path: "registrazione",
        component: RegistrazionePage,
        name: "Registrazione",
    }, {
        id: "recupera-password",
        path: "recupera-password",
        component: RecuperaPasswordPage,
        name: "Recupera password",
    }, {
        id: "attiva-utente",
        path: "attiva-utente/:id/:code",
        component: AttivaUtentePage,
        name: "Attiva utente",
    }, {
        id: "profilo",
        path: "profilo",
        component: ProfiloPage,
        name: "Profilo",
        private: true,
    }, {
        id: "cambia-password",
        path: "profilo/cambia-password",
        component: CambiaPasswordPage,
        name: "Profilo",
        private: true,
    }, {
        id: "logout",
        path: "logout",
        component: LogoutPage,
        name: "logout",
        private: true,
    }];
}
